import {
  NON_BB_COURSES,
  AP_BIOLOGY,
  AP_CALCULUS_AB,
  AP_CALCULUS_BC,
  AP_ENGLISH_LANG,
  AP_ENGLISH_LIT,
  AP_CHEMISTRY,
  AP_MACROECONOMICS,
  AP_MICROECONOMICS,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_EM,
  AP_PHYSICS_C_MECHANIC,
  AP_PRE_CALCULUS,
  AP_STATISTIC,
  AP_ART_HISTORY,
  AP_COMP_GO_PO,
  AP_CSA,
  AP_COMPUTER_SCIENCE_PRINCIPLES,
  AP_ENVIRONMENTAL_SCI,
  AP_EUROPEAN_HIS,
  AP_HUMAN_GEOGRAPHY,
  AP_LATIN,
  AP_PHYSCOLOGY,
  AP_SEMINAR,
  AP_US_GOV_POL,
  AP_US_HISTORY,
  AP_WORLD_HISTORY,
} from 'chameleon-src/constants/subjects';

const HYBRID_COURSES = [
  AP_BIOLOGY,
  AP_CALCULUS_AB,
  AP_CALCULUS_BC,
  AP_CHEMISTRY,
  AP_MACROECONOMICS,
  AP_MICROECONOMICS,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_EM,
  AP_PHYSICS_C_MECHANIC,
  AP_PRE_CALCULUS,
  AP_STATISTIC,
];

const NON_ENGLISH_BB_COURSES = [
  AP_ART_HISTORY,
  AP_COMP_GO_PO,
  AP_CSA,
  AP_COMPUTER_SCIENCE_PRINCIPLES,
  AP_ENVIRONMENTAL_SCI,
  AP_EUROPEAN_HIS,
  AP_HUMAN_GEOGRAPHY,
  AP_LATIN,
  AP_PHYSCOLOGY,
  AP_SEMINAR,
  AP_US_GOV_POL,
  AP_US_HISTORY,
  AP_WORLD_HISTORY,
];

export const ENGLISH_BB_COURSES = [AP_ENGLISH_LANG, AP_ENGLISH_LIT];

export const getCourseType = (masterSubjectId) => {
  if (HYBRID_COURSES.includes(masterSubjectId)) {
    return 'HYBRID';
  }

  if (NON_ENGLISH_BB_COURSES.includes(masterSubjectId)) {
    return 'NON_ENGLISH_BB';
  }

  if (ENGLISH_BB_COURSES.includes(masterSubjectId)) {
    return 'ENGLISH_BB';
  }
  if (NON_BB_COURSES.includes(masterSubjectId)) {
    return 'NON_BB';
  }
  return undefined;
};

const COURSES_WITH_BLUEBOOK_NOTE = [
  ...HYBRID_COURSES,
  ...NON_ENGLISH_BB_COURSES,
  ...ENGLISH_BB_COURSES,
];

export const shouldShowBluebookNote = (masterSubjectId) =>
  COURSES_WITH_BLUEBOOK_NOTE.includes(masterSubjectId);

export const isNonBBCourse = (masterSubjectId) =>
  NON_BB_COURSES.includes(masterSubjectId);
